import { useState } from "react"
import HtmlParser from "react-html-parser"
import { Article, BackgroundColor, useGetCommonTranslations } from "api"
import { isServer } from "lib"

import { ButtonShare } from "ui/atoms/button-share"

interface Props {
  article: Article
  background: BackgroundColor
}

const ALERT_TIMEOUT = 3000

export function Sharing(props: Props) {
  const { data } = useGetCommonTranslations()
  const [showAlert, setShowAlert] = useState<boolean>(false)
  const { article, background } = props

  const shareLink = isServer() ? "" : window?.location.href

  const handleShare = async () => {
    if (isServer()) return

    const shareData = {
      title: article.meta?.title || article.title || "",
      text: article.meta?.description || article.description || "",
      url: window.location.href,
    }

    if (navigator.share) {
      try {
        await navigator.share(shareData)
      } catch (error) {
        copyLink()
      }
    } else {
      copyLink()
    }
  }

  const copyLink = () => {
    navigator.clipboard.writeText(shareLink)
    setShowAlert(true)
    setTimeout(() => {
      setShowAlert(false)
    }, ALERT_TIMEOUT)
  }

  return (
    <div className="content-center py-6 text-black md:flex">
      <div className="flex w-full justify-between md:max-w-[312px] relative">
        <ButtonShare
          background={background}
          text={data?.locales["share_article"] ?? ""}
          onClick={handleShare}
        />
        {showAlert && (
          <div
            className="absolute -top-10 -right-3 my-[3px] rounded-[20px] bg-gold py-1 px-3 text-sm text-black duration-300 md:top-0 md:left-10 md:right-auto"
            onClick={() => setShowAlert(false)}
          >
            {HtmlParser(data?.locales["copied"] || "")}
          </div>
        )}
      </div>
    </div>
  )
}
